module.exports = __webpack_public_path__ + "img/patrulla_stj_up.403464b7.svg";